import { Link } from "react-router-dom";
import { FOOTER, BRAND } from "@/lib/constants";
import { MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1A1A] text-white"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand column */}
          <div className="space-y-4 md:col-span-1">
            <h3 className="font-heading text-xl font-bold text-white">
              {BRAND.name}
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              {FOOTER.brand}
            </p>
            <p className="text-sm text-gray-400">{FOOTER.abn}</p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <MapPin className="h-4 w-4 text-[#D4A84B]" />
              <span>{FOOTER.australianBadge}</span>
            </div>
          </div>

          {/* Navigation column */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">
              Navigation
            </h4>
            <div className="flex flex-col gap-2">
              {FOOTER.navLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                  data-testid={`footer-nav-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Legal column */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">
              Legal
            </h4>
            <div className="flex flex-col gap-2">
              {FOOTER.links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                  data-testid={`footer-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact column */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">
              Contact
            </h4>
            <a
              href={`mailto:${FOOTER.email}`}
              className="text-sm text-gray-400 hover:text-white transition-colors block"
              data-testid="footer-email"
            >
              {FOOTER.email}
            </a>
            {FOOTER.phone && (
              <p className="text-sm text-gray-400">{FOOTER.phone}</p>
            )}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-10 pt-6 text-center">
          <p className="text-xs text-gray-500">
            {FOOTER.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}
